import { Header as ReactAriaHeader } from "react-aria-components";
import { cn } from "../../../utilities/tailwind";

export type HeaderProperties = React.HTMLAttributes<HTMLElement> & {
  className?: string | undefined;
  label?: string | undefined;
};
export const Header = ({
  className = "",
  label,
  ...properties
}: HeaderProperties) => {
  const twClassname = cn(
    "pointer-events-none mx-6 mt-2 flex min-h-8 items-center text-legal! text-slate-gray uppercase",
    className,
  );

  return (
    <ReactAriaHeader className={twClassname} {...properties}>
      {properties.children ?? label}
    </ReactAriaHeader>
  );
};
Header.displayName = "InputComboBox.Header";
